var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M23 5.5C20 3.5 15 3.5 12 5.5V20.5C13 18.5 21 18.5 23 20.5V5.5Z","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1 5.5C4 3.5 9 3.5 12 5.5V20.5C11 18.5 3 18.5 1 20.5V5.5Z","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }